// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("@/assets/svg/background.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("@/assets/svg/background-register.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
exports.push([module.id, ".wave-bg[data-v-5953b51c]{background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-position:100% 100%;background-repeat:no-repeat;background-size:50vw}.register-bg[data-v-5953b51c]{background-color:#f8f9f9;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ");background-repeat:no-repeat;background-position-x:center;background-position-y:bottom;background-size:70vw}", ""]);
// Exports
module.exports = exports;
